import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BookingProvider } from './context/BookingContext';
import { UserProvider } from './context/UserContext';
import ProtectedRoute from './components/ProtectedRoute';

import HomePage from './pages/HomePage';
import TimeSlotPage from './pages/TimeSlotPage';
import RequirementsPage from './pages/RequirementsPage';
import ConfirmationPage from './pages/ConfirmationPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminLoginPage from './pages/AdminLoginPage';
import ViewAllBookingsPage from './pages/ViewAllBookingsPage';
import ManageAdminsPage from './pages/ManageAdminsPage';
import MyBookingsPage from './pages/MyBookingsPage';

function App() {
  return (
    <UserProvider>
      <BookingProvider>
        <Router>
          <div className="min-h-screen">
            <Routes>
              <Route path="/" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/adminlogin" element={<AdminLoginPage />} />
              <Route path="/home" element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              } />
              <Route path="/time-slot" element={
                <ProtectedRoute>
                  <TimeSlotPage />
                </ProtectedRoute>
              } />
              <Route path="/requirements" element={
                <ProtectedRoute>
                  <RequirementsPage />
                </ProtectedRoute>
              } />
              <Route path="/my-bookings" element={
                <ProtectedRoute>
                  <MyBookingsPage />
                </ProtectedRoute>
              } />
              <Route path="/confirmation" element={
                <ProtectedRoute>
                  <ConfirmationPage />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminDashboardPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/bookings" element={
                <ProtectedRoute requireAdmin={true}>
                  <ViewAllBookingsPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/manage-admins" element={
                <ProtectedRoute requireAdmin={true}>
                  <ManageAdminsPage />
                </ProtectedRoute>
              } />
            </Routes>
          </div>
        </Router>
      </BookingProvider>
    </UserProvider>
  );
}

export default App;
